import './buffer-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { WalletLiveProvider } from './auth/WalletLiveContext';
import { TonConnectShell } from './tonconnect/TonConnectShell';
import './i18n';
import './styles/global.css';
import './styles/components.css';
import './styles/auth-modal.css';

const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <WalletLiveProvider>
            <TonConnectShell>
              <App />
            </TonConnectShell>
          </WalletLiveProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
}
